module.exports = __webpack_public_path__ + "media/images/themes/light/select-arrows-dark-82bccf2bd5bf353b023101ee17254c1b.svg";